/*
 * @Author: yejianfei
 * @Date: 2023-04-04 20:58:29
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-06 12:15:15
 * @Description:
 * @Developer:
 */
import { Modal, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import APIForm from './APIForm';
import Separator from '../Separator';
export default function (props) {
    const [isLoading, setLoading] = useState(false);
    const [isOpened, setOpened] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const form = useRef(null);
    useEffect(() => {
        setOpened(props.open);
    }, [props.open]);
    return (React.createElement(Modal, Object.assign({}, props, { open: isOpened, destroyOnClose: true, 
        // forceRender
        confirmLoading: isLoading, okText: '\u786E\u5B9A', cancelText: '\u53D6\u6D88', onOk: () => { var _a; return (_a = form.current) === null || _a === void 0 ? void 0 : _a.submit(); }, onCancel: () => setOpened(false) }),
        React.createElement(Separator, { size: 12 }),
        React.createElement(APIForm, Object.assign({ ref: form }, props.form, { onBeforeRequest: (method, values) => {
                setLoading(true);
                return props.form.onBeforeRequest
                    ? props.form.onBeforeRequest(method, values)
                    : values;
            }, onRequestSucceeded: (method, res, values) => {
                var _a;
                props.form.onRequestSucceeded && props.form.onRequestSucceeded(method, res, values);
                setLoading(false);
                setOpened(false);
                props.form.onSucceededMessage ? props.form.onSucceededMessage(method, res, values) : messageApi.open(((_a = props.form.message) === null || _a === void 0 ? void 0 : _a.succeeded) || {
                    type: 'success',
                    content: 'Submitted successfully！'
                });
            }, onRequestFailed: (method, err, values) => {
                var _a;
                setLoading(false);
                props.form.onRequestFailed && props.form.onRequestFailed(method, err, values);
                props.form.onFailedMessage ? props.form.onFailedMessage(method, err, values) : messageApi.open(((_a = props.form.message) === null || _a === void 0 ? void 0 : _a.failed) || {
                    type: 'error',
                    content: `Submission Failed！ - ${err}`
                });
            } }), props.children),
        contextHolder));
}
